import axios from '@/axios';

export async function getUnities(params) {
    const { data } = await axios.get("/unities/list", { params });
    return data;
}

export async function getAllOrgons() {
    const { data } = await axios.get("/orgon");
    return data.data ? data.data : data;
}

export async function getMunicipalities() {
    const { data } = await axios.get("/unities/municipality");
    return data.data ? data.data : data;
}

export async function getOpoReferences() {
    const { data } = await axios.get("/references/by_type_reference/1");
    return data.data ? data.data : data;
}

export async function getOpcReferences() {
    const { data } = await axios.get("/references/by_type_reference/2");
    return data.data ? data.data : data;
}

export async function saveUnity(id, data) {
    const method = id ? 'PUT' : 'POST';
    const url = id ? `/unities/${id}` : `/unities`;
    return await axios({ method, url, data: data });
}
